import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";

const updateGetEmployeesCache = ({ employees, variables }) => {
  try {
    if (employees && employees.length) {
      const cacheKey = {
        query: require("../api/query/getEmployees.gql"),
        variables: variables,
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getEmployees) {
        employees.forEach(obj => {
          const existingIndex = cachedData.getEmployees.employees.findIndex(
            x => x._id === obj._id
          );

          if (existingIndex < 0) {
            cachedData.getEmployees.employees.unshift(obj);
          }
        });

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    // console.log(
    //   "createEmployees.updateGetEmployeesCache:exception:",
    //   e.message
    // );
  }
};

export const createEmployees = (input, queryVariables) => {
  const mutation = require("../api/mutation/createEmployees.gql");
  const variables = { input: input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetEmployeesCache({
        employees: data.createEmployees.employees,
        variables: { limit: 0, skip: 0 },
      });

      return { data: data.createEmployees };
    } else if (error) return { error: JSON.stringify(error) };
  });
};

export const createEmployee = input => {
  const mutation = require("../api/mutation/createEmployee.gql");
  const variables = { input: input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetEmployeesCache({
        employees: [data.createEmployee],
        variables: {
          limit: 0,
          skip: 0,
        },
      });
      return { data: data.createEmployee };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
